import styles from './MeetNinjaSection.module.scss';

type MeetNinjaSectionProps = {
  isSignup: boolean;
};

export const MeetNinjaSection = ({ isSignup }: MeetNinjaSectionProps) => {
  return (
    <div className={styles.root}>
      <h1 className={styles.meetNinja}>Meet Ninja</h1>
      {!isSignup && (
        <h4 className={styles.productivity}>
          Your All-In-One AI Agent for Unlimited Productivity
        </h4>
      )}
    </div>
  );
};
